import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	allEnvironmentSelectLabel: {
		id: 'software-deployments.top-filters.environment-filter.utils.all-environment-select-label',
		defaultMessage: 'All {envType} environments',
		description: 'Label to select all environments of the given environment type',
	},
	production: {
		id: 'software-deployments.top-filters.environment-filter.utils.production',
		defaultMessage: 'Production',
		description: 'Group select item label for production environment names',
	},
	staging: {
		id: 'software-deployments.top-filters.environment-filter.utils.staging',
		defaultMessage: 'Staging',
		description: 'Group select item label for staging environment names',
	},
	testing: {
		id: 'software-deployments.top-filters.environment-filter.utils.testing',
		defaultMessage: 'Testing',
		description: 'Group select item label for testing environment names',
	},
	development: {
		id: 'software-deployments.top-filters.environment-filter.utils.development',
		defaultMessage: 'Development',
		description: 'Group select item label for development environment names',
	},
	unmapped: {
		id: 'software-deployments.top-filters.environment-filter.utils.unmapped',
		defaultMessage: 'Unmapped',
		description: 'Group select item label for unmapped environment names',
	},
});
